import React from "react";
import PropTypes from "prop-types";
import { InputField } from '@getgo/chameleon-web-react-wrapper';
import classes from "./otp-input.scss";

export const OTPInput = ({
  length = 6,
  error,
  handleChange,
  handleInputBlur,
  handleKeyDown,
  handlePaste,
  inputRefs,
  otp,
}) => {
  return (
    <div className={classes["otpContainer"]}>
      <div className={classes["otpInputs"]} onPaste={handlePaste}>
        {Array.from({ length: length }, (_, index) => (
          <React.Fragment key={index}>
            <InputField
              fieldsize="xlarge"
              ref={(el) => (inputRefs.current[index] = el)}
              id={`otp-input-${index}`}
              type="tel"
              maxLength={1}
              value={otp[index] || ""}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              onBlur={() => handleInputBlur(index)}
              className={classes["otpInput"]}
              error={error === "invalid-code"}
              autoComplete="one-time-code"
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

OTPInput.propTypes = {
  length: PropTypes.number,
  error: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleInputBlur: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  handlePaste: PropTypes.func.isRequired,
  inputRefs: PropTypes.object.isRequired,
  otp: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OTPInput;
